export default __webpack_public_path__ + "static/media/banner_1_1_11zon.4d8ef651.webp";